import React from 'react';
import { WorkflowChain } from '../WorkflowChain';
import { DigitalChain } from '../DigitalChain';
import { useBeats } from '../../hooks/useBeats';
import { PRODUCT_NAME, journeyResolved, preloadedImage, preloadedImageAlt, workflow } from '../../data/teaser';
const BEATS = [900, 1500, 1800, 2100, 2400, 3200, 3900, 4600];
export function ScreenMissingLink() {
  const beat = useBeats(BEATS);
  return <section className="flex h-full w-full flex-col justify-center" data-id="element-128" data-mp="3vr91s2bw2kpw">
      <h1 className="text-[27px] font-extrabold leading-[1.14] text-white animate-fade-in-up" data-id="element-129" data-mp="3rovwff120otn">
        So we created the missing link.
      </h1>

      <p className={`mt-3 font-headline text-[15px] font-bold tracking-[0.02em] text-solventum-primary transition-[opacity,transform] duration-300 ease-out ${beat >= 1 ? 'translate-y-0 opacity-100' : 'translate-y-1.5 opacity-0'}`} data-id="element-130" data-mp="9c7iylq3ll0f">
        {PRODUCT_NAME}
      </p>

      <div className={`mt-5 overflow-hidden rounded-2xl border border-white/10 bg-black/30 transition-[opacity,transform] duration-300 ease-out ${beat >= 1 ? 'scale-100 opacity-100' : 'scale-[0.98] opacity-0'}`} data-id="element-131" data-mp="3803mbo9v1ug4">
        <img src={preloadedImage} alt={preloadedImageAlt} className="h-28 w-full object-cover animate-ken-burns" data-id="element-132" data-mp="1fz0caz4nihyp" />
      </div>

      <div className="mt-5" data-id="element-133" data-mp="1kx1wxohq6pca">
        <WorkflowChain steps={workflow} revealed={Math.max(0, beat - 1)} data-id="element-134" data-mp="na2wr3rtqz9n" />
      </div>

      <p className={`mt-6 font-headline text-[20px] font-extrabold leading-snug text-white transition-[opacity,transform] duration-300 ease-out ${beat >= 6 ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} data-id="element-135" data-mp="ncflbzs387vo">
        Now the attachment joins the digital workflow.
      </p>

      <div className={`mt-6 border-t border-white/10 pt-5 transition-opacity duration-300 ease-out ${beat >= 7 ? 'opacity-100' : 'opacity-0'}`} data-id="element-136" data-mp="28npdey5pinag">
        <DigitalChain steps={journeyResolved} revealed={beat >= 7 ? journeyResolved.length : 0} complete={beat >= 8} orientation="horizontal" data-id="element-137" data-mp="2cqvgjwxivycp" />
      </div>
    </section>;
}